// extracted by mini-css-extract-plugin
export default {"position-page":"PositionPage_position-page__bNXu0","positions-title":"PositionPage_positions-title__zL5uF"};